import { connect } from 'react-redux';
import Auction from 'components/auctions/Auction';
import {
  clearImages,
  clearCurrentAuction,
  clearAuctionBids,
} from 'data/auctions/Auctions.actions';
import { clearAuctionParty } from 'data/parties/Parties.actions';
import { PartyTypes } from 'vdlib';

export default connect(
  () => ({}),
  dispatch => ({
    clear: () => {
      dispatch(clearAuctionBids());
      dispatch(clearCurrentAuction());
      dispatch(clearAuctionParty(PartyTypes.Merchant));
      dispatch(clearAuctionParty(PartyTypes.Insurance));
      dispatch(clearImages());
    },
  }),
)(Auction);
